// Module
var code = "<div class=\"contextual-header\"> <wt-contextual-title class=\"lead\" title-text=\"vm.titleText\" trackable=\"vm.trackable\"> </wt-contextual-title> </div> <div class=\"contextual-content\"> <ng-transclude></ng-transclude> </div>";
// Exports
module.exports = code;